<template>
  <BigButton
    :loading="printLoading"
    v-slot:default="{ textColor }"
    @click="action"
  >
    <slot :textColor="textColor" />
    <EsignButton
      v-model="dialog"
      :esign="esign"
      :callback="downloadArchive"
      hideButton
      v-if="esign"
    />
  </BigButton>
</template>

<script>
export default {
  name: "MedicalCertificateButton",
  props: {
    attendance: Object,
    medicalCertificateType: String,
    newMedicalCertificate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printLoading: false,
      esign: null,
      dialog: null,
    };
  },
  methods: {
    medicalCertificateByType() {
      return this.$apollo
        .query({
          query: require("@/graphql/medical_certificate/medical_certificate_by_type.gql"),
          fetchPolicy: "no-cache",
          variables: {
            attendanceId: this.attendance.id,
            medicalCertificateType: this.medicalCertificateType,
          },
        })
        .then(({ data }) => {
          return data.medicalCertificateByType;
        });
    },
    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.esign.id,
          dynamicForm: true,
          examAppraisal: true,
        },
      });
      await setTimeout(this.$apollo.queries.medicalCertificateByType, 2000);
    },
    async downloadArchive() {
      this.printLoading = true;
      await this.generatePreview();
      await this.medicalCertificateByType().then((medicalCertificate) => {
        this.esign = medicalCertificate.lastEsign;

        //if (this.esign.status === "signed") {
        const file_url = this.esign.fileUrl;

        window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
        // } else {
        //   this.$store.dispatch("createNotification", {
        //     message: "É necessário assinar antes de imprimir.",
        //     type: "error",
        //   });
        // }

        this.printLoading = false;
      });
    },
    downloadFile() {
      this.printLoading = true;

      this.medicalCertificateByType().then((medicalCertificate) => {
        this.esign = medicalCertificate.lastEsign;

        if (this.esign.status === "signed") {
          this.downloadArchive();
        } else {
          this.dialog = true;
        }

        this.printLoading = false;
      });
    },
    createMedicalCertificate() {
      this.printLoading = true;

      this.medicalCertificateByType().then((medicalCertificate) => {
        this.printLoading = false;
        this.$router.push(`atestados/${medicalCertificate.id}`);
      });
    },
    action() {
      if (this.newMedicalCertificate) {
        this.createMedicalCertificate();
      } else {
        this.downloadFile();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
